<div class="main">
    <div dir="rtl">
        <h2 style="text-align: center;">שטעט ליסט</h2>
        <div class="newBtn">
            <p>
                <a class="btn btn-primary" routerLink="/admin/city/new">New City</a>
            </p>
        </div>
        <div class="filter">
            <div class="filter2">
                <input class="form-control" placeholder="search" (keyup)="onSearch()" [(ngModel)]="filter" />
            </div>
        </div>
        <div class="tableHolder">
            <div class="tbl" dir="rtl">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="שטאט">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> שטאט</th>
                          <td mat-cell *matCellDef="let m" style="text-align: center;"> {{ m.cityY }} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="city">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> City </th>
                          <td mat-cell *matCellDef="let m" style="text-align: center;"> {{ m.cityE }} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="לאנד">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;">לאנד</th>
                          <td mat-cell *matCellDef="let m" style="text-align: center;"> {{ m.state.stateY }} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="actions">
                          <th mat-header-cell *matHeaderCellDef>
                            <span style="text-align: center;">
                                <i class="fa fa-gear"></i>
                            </span>
                          </th>
                          <td mat-cell *matCellDef="let m" dir="ltr">
                            <div class="d-flex">
                                <a (click)="onDelete(m.id)" title="Delete State" style="margin-right: 15px; cursor: pointer">
                                  <i class="fa fa-remove"></i>
                                </a>
                                <a title="Edit State" [href]="'/admin/city/' + m.id">
                                  <i class="fa fa-edit"></i>
                                </a>
                            </div>
                          </td>
                          
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      
                        <tr mat-row *matRowDef="let m; columns: displayedColumns;"></tr>
                      
                      </table>
                      
                      <mat-paginator [pageSizeOptions]="[10, 50, 100]"
                                     showFirstLastButtons
                                     aria-label="Select page of periodic elements">
                      </mat-paginator>
                  </div>
            </div>
        </div>  
    </div>
</div>